<template>
    <div class="container">
        <div class="grid grid-cols-12">
            <div class="col-span-12 lg:col-span-10 lg:col-start-2 mt-4">
                <div class="flex items-center text-xs pt-12 lg:pt-8 overflow-x-hidden mb-8">
                    <nuxt-link class="link text-sm font-Inter-Semibold" to="/">{{ $t('common.home') }}</nuxt-link>
                    <nuxt-link class="link whitespace-nowrap lg:whitespace-normal text-sm" :to="localePath('magazine')"
                        >{{ $t('menu.magazine') }}</nuxt-link
                    >
                    <nuxt-link
                        v-if="model?.title && model?.slug"
                        class="link whitespace-nowrap lg:whitespace-normal text-sm opacity-50 pointer-events-none"
                        :to="`magazine/${model?.slug}`"
                    >
                        {{ model?.title }}</nuxt-link
                    >
                </div>
                <div class="lg:aspect-w-16 lg:aspect-h-8 overflow-hidden rounded-lg relative">
                    <app-image
                        v-if="model?.extraimage"
                        class="object-cover min-h-[65vh] lg:h-auto lg:min-h-full"
                        :src="model.extraimage"
                        :alt="model.title || ''"
                        preset="hero"
                        eager
                    />
                    <div
                        class="absolute w-full h-full hero-text flex flex-col justify-end fig text-white px-4 lg:px-24 pb-8 lg:pb-14 bottom-0"
                    >
                        <h3 v-if="model?.public_date" class="text-sm mb-3 font-Inter-Semibold">
                            {{ model?.public_date }}
                        </h3>
                        <h1 v-if="model?.title" class="text-xl lg:text-3xl font-Inter-Bold mb-4 w-full lg:w-9/12">
                            {{ model?.title }}
                        </h1>
                        <h2
                            v-if="model?.lead"
                            class="text-sm lg:text-[1.0625rem] leading-6 font-Inter-Regular w-full lg:w-10/12"
                        >
                            {{ model?.lead }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-8 lg:col-start-3">
                <div v-if="model?.text" class="tinymce-content mt-8 lg:mt-12" v-html="model?.text"></div>
                <div class="grid grid-cols-12 lg:gap-x-8 mt-8">
                    <div class="col-span-12 lg:col-span-7 flex items-center">
                        <div v-if="model?.text2" class="tinymce-content mt-8 lg:mt-12" v-html="model?.text2"></div>
                    </div>
                    <div class="col-span-12 lg:col-span-5 flex items-center justify-center">
                        <ProductCard
                            v-if="model?.connected_products && model?.connected_products.length"
                            :title="model?.connected_products[0]?.name"
                            :rating="3.5"
                            :product="model?.connected_products[0]"
                            :slug="
                                localePath({
                                    name: 'products-category-product',
                                    params: {
                                        category: model?.connected_products[0]?.category_slug,
                                        product: model?.connected_products[0]?.slug,
                                    },
                                })
                            "
                            :brutto-price="model?.connected_products[0]?.price"
                            :is-favorite="model?.connected_products[0]?.isFavorite"
                            :price="model?.connected_products[0]?.price"
                            :image="model?.connected_products[0]?.preview"
                        />
                    </div>
                </div>
                <div v-if="model?.text3" class="tinymce-content mt-8 lg:mt-12" v-html="model?.text3"></div>
                <div class="grid grid-cols-12 gap-x-8 mt-12">
                    <div class="col-span-12 lg:col-span-5 flex items-center justify-center order-2 lg-order-1">
                        <ProductCard
                            v-if="model?.connected_products && model?.connected_products.length > 1"
                            :title="model?.connected_products[1]?.name"
                            :rating="3.5"
                            :product="model?.connected_products[1]"
                            :slug="
                                localePath({
                                    name: 'products-category-product',
                                    params: {
                                        category: model?.connected_products[1]?.category_slug,
                                        product: model?.connected_products[1]?.slug,
                                    },
                                })
                            "
                            class="h-full w-full"
                            :brutto-price="model?.connected_products[1]?.price"
                            :is-favorite="model?.connected_products[1]?.isFavorite"
                            :price="model?.connected_products[1]?.price"
                            :image="model?.connected_products[1]?.preview"
                        />
                    </div>
                    <div class="col-span-12 lg:col-span-7 flex items-center lg-order-2">
                        <div v-if="model?.text4" class="tinymce-content mt-8 lg:mt-12" v-html="model?.text4"></div>
                    </div>
                </div>
                <div v-if="model?.text5" class="tinymce-content mt-8 lg:mt-12" v-html="model?.text5"></div>
                <div id="contentEnd" ref="contentEnd"></div>
            </div>
            <div
                v-if="model?.connected_articles && model?.connected_articles.length"
                class="col-span-12 lg:col-span-10 lg:col-start-2 mt-14 lg:mt-20"
            >
                <SectionIntro :title="$t('magazine.related_posts')" md />
                <div class="grid grid-cols-12 gap-y-8 lg:gap-x-8 lg:gap-y-0">
                    <div
                        v-for="(article, i) in model?.connected_articles.slice(0, 3)"
                        :key="`related_article_${i}`"
                        class="col-span-12 lg:col-span-4"
                    >
                        <ArticleCard
                            :title="article.title"
                            :img-src="article.image"
                            :publish-date="article.public_date"
                            :description="article?.lead"
                            :category="article.category"
                            :url="
                                localePath({
                                    name: 'magazine-article',
                                    params: {
                                        article: article?.slug,
                                    },
                                })
                            "
                            minutes="4"
                            md
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArticleCard from '@/components/Cards/ArticleCard/ArticleCard.vue';
import ProductCard from '@/components/Cards/ProductCard/ProductCard.vue';
export default {
    name: 'Article',
    components: {
        ProductCard,
        ArticleCard,
    },
    async asyncData({ $axios, params, error }) {
        let model = null;

        try {
            await $axios
                .$get(`/article/${params.article}`)
                .then((res) => {
                    if (res) {
                        model = res.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }
        return { model };
    },
    data: function () {
        return {
            height: 0,
        };
    },
    head() {
        const meta = [
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.model?.meta_title || this.model?.title,
            },
            {
                hid: 'title',
                name: 'title',
                content: this.model?.meta_title || this.model?.title,
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.model?.meta_description || this.model?.lead,
            },
            {
                hid: 'description',
                name: 'description',
                content: this.model?.meta_description || this.model?.lead,
            },
        ];

        if (this.model?.image) {
            meta.push({
                hid: 'og:image',
                property: 'og:image',
                content: this.model?.ogimage || this.model?.image,
            });
            meta.push({
                hid: 'og:image:url',
                property: 'og:image:url',
                content: this.model?.ogimage || this.model?.image,
            });
        }

        return {
            title: this.model?.meta_title || this.model?.title,
            meta,
        };
    },
    mounted() {
        this.height = window.innerHeight;
        this.$store.commit('blog/setCurrentArticleHeight', this.$refs.contentEnd.offsetTop - window.innerHeight);
        setTimeout(() => {
            this.$store.commit('blog/setDoesProgressBarHaveTransition', true);
        }, 110);
    },
    beforeDestroy() {
        this.$store.commit('blog/setDoesProgressBarHaveTransition', false);
        this.$store.commit('blog/setCurrentArticleHeight', 0);
    },
};
</script>

<style scoped>
.product-card,
.product-card__inner-wrapper {
    height: auto !important;
    background-color: rgba(25, 103, 210, 0);
}

.hero-text {
    background: linear-gradient(353deg, rgba(29, 29, 29, 0.5) 27.23%, rgba(29, 29, 29, 0) 95.53%);
    @media (max-width: 992px) {
        background: linear-gradient(353deg, rgba(29, 29, 29, 0.7) 27.23%, rgba(29, 29, 29, 0) 100%);
    }
}
.link {
    &::after {
        content: '/';
        @apply mx-3;
    }
    &:last-of-type {
        @apply opacity-50 pointer-events-none;
        &::after {
            content: none;
        }
    }
}

.lg-order-1 {
    @media (min-width: 992px) {
        order: 1 !important;
    }
}
.lg-order-2 {
    @media (min-width: 992px) {
        order: 2 !important;
    }
}
</style>
